import React from "react";
import { money } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { PaymentSplits } from "@/components/invoice/PaymentSplits";

const Row = ({ label, value, neg, testid }) => (
  <div className={`flex justify-between ${neg ? "text-rose-600" : ""}`}><span className={neg ? "" : "text-slate-500"}>{label}</span><span className="font-mono" data-testid={testid}>{neg ? "-" : ""}{money(Math.abs(value))}</span></div>
);

export function SummaryCard({ calc, roundOff, setRoundOff, splits, setSplits, showPayments }) {
  const s = calc.summary;
  const gb = calc.tpRows.filter((r) => r.mode === "before" && r.amount); const ga = calc.tpRows.filter((r) => r.mode === "after" && r.amount);
  const db = calc.discRows.filter((r) => r.mode === "before" && r.amount); const da = calc.discRows.filter((r) => r.mode === "after" && r.amount);
  return (
    <Card className="p-4 border-slate-200 space-y-1.5 text-sm" data-testid="di-summary">
      <Row label="Items Total" value={s.items_total} testid="di-sum-items" />
      {gb.map((r, i) => <Row key={`gb${i}`} label={`${r.narration || "TP"} (${r.percent || 0}%)`} value={r.amount} neg={r.amount < 0} />)}
      {db.map((r, i) => <Row key={`db${i}`} label={r.label || "Discount"} value={r.amount} neg />)}
      <Row label="Taxable Value" value={s.taxable_total} testid="di-sum-taxable" />
      <Row label="GST" value={s.tax_total} testid="di-sum-tax" />
      {s.item_tp_after !== 0 && <Row label="Item TP (after tax)" value={s.item_tp_after} neg={s.item_tp_after < 0} />}
      {ga.map((r, i) => <Row key={`ga${i}`} label={`${r.narration || "TP"} (${r.percent || 0}%)`} value={r.amount} neg={r.amount < 0} />)}
      {calc.chRows.filter((c) => c.amount).map((c, i) => <Row key={`c${i}`} label={c.label || "Charge"} value={c.amount} />)}
      {da.map((r, i) => <Row key={`da${i}`} label={`${r.label || "Discount"} (after tax)`} value={r.amount} neg />)}
      <div className="flex justify-between items-center"><label className="flex items-center gap-2 text-slate-500"><Switch checked={roundOff} onCheckedChange={setRoundOff} data-testid="di-round-off" />Auto Round Off</label><span className="font-mono" data-testid="di-round-value">{money(s.round_off)}</span></div>
      <div className="flex justify-between font-bold text-[#1A2A5E] text-base pt-2 border-t"><span>Total</span><span className="font-mono" data-testid="di-grand">{money(s.grand_total)}</span></div>
      {showPayments && <PaymentSplits splits={splits} setSplits={setSplits} grand={s.grand_total} />}
    </Card>
  );
}
